import { InvestProject } from '../invest-project';
import { InvestProjectYear } from '../invest-project-year';

export class InvestProjectBbc extends InvestProject {
    years: InvestProjectYear[];

    constructor(name: string, year?: number) {
        super(name);

        this.years = [new InvestProjectYear(year || null)];
    }
}
